import { Status, useFetchRefactored } from 'civic-champs-shared/api/hooks'
import { find, isEmpty, map } from 'lodash'
import { useCallback } from 'react'
import { CheckIn, EditableCheckOut } from '../types'
import moment from 'moment'

export interface TimesheetEvent {
  action: 'check-in' | 'check-out'
  personId: number
  opportunityId: number
  occurredAt: Date
  data: {
    role?: number
    updatedCheckedInAt?: Date
  }
}

export const useTimesheetCheckOut = (): [
  (checkOuts: EditableCheckOut[], checkIns?: CheckIn[]) => Promise<void>,
  Status<void>,
] => {
  const [request, status] = useFetchRefactored<void>()

  //TODO probably should return something?
  const checkOut = useCallback(
    async (checkOuts: EditableCheckOut[], checkIns?: CheckIn[]) => {
      const timesheetEvents = map<EditableCheckOut, TimesheetEvent>(checkOuts, checkOut => {
        const event: TimesheetEvent = {
          action: 'check-out',
          personId: checkOut.user.id,
          opportunityId: checkOut.shift.opportunityId,
          occurredAt: checkOut.checkedOutAt,
          data: checkOut.role ? { role: checkOut.role.id } : {},
        }

        // rather than changing the POST /timesheet semantics to detect if an updated check-in
        // time is different from the original, do a check here instead
        let checkInTimeChanged = true
        if (checkIns) {
          const checkIn = find(checkIns, checkIn => checkIn.id === checkOut.activeVolunteerId)
          if (checkIn) {
            const originalCheckInTime = moment(checkIn.checkedInAt)
            checkInTimeChanged = !originalCheckInTime.isSame(checkOut.checkedInAt, 'minute')
          }
        }

        if (checkInTimeChanged) {
          event.data.updatedCheckedInAt = checkOut.checkedInAt
        }

        return event
      })

      if (isEmpty(timesheetEvents)) return

      await request({
        method: 'post',
        url: '/timesheet',
        config: {
          body: timesheetEvents,
        },
      })
    },
    [request],
  )

  return [checkOut, status]
}
